import Cookies from "js-cookie";
import {
  LANGUAGE_EN_US_CODE,
  LANGUAGE_FR_CODE,
  PELICAN_CHECKOUT_COOKIES_CA,
  PELICAN_CHECKOUT_COOKIES_US,
} from "../constants/AppConstants";
import { getCurrentLanguageCode } from "./helpers";

/**
 * Get main website domain for cross-domain cookies
 * @returns {string} Main domain without www
 */
const getMainWebsiteDomain = () => {
  const headerElement = document.querySelector("body");
  let mainWebsiteDomain = headerElement?.getAttribute("data-main-website");

  if (mainWebsiteDomain) {
    return mainWebsiteDomain.replace("www.", "").replace(/\/$/, "");
  }
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  if (parts.length > 2) {
    return parts.slice(-2).join(".");
  }

  return hostname.replace("www.", "");
};

/**
 * Get language-specific cookie name
 * @returns {string} Cookie name based on current language
 */
const getCartCookieName = () => {
  const currentLanguage = getCurrentLanguageCode(LANGUAGE_FR_CODE);
  return currentLanguage === LANGUAGE_EN_US_CODE
    ? PELICAN_CHECKOUT_COOKIES_US
    : PELICAN_CHECKOUT_COOKIES_CA;
};

/**
 * Set cart ID in cross-domain cookie
 * @param {string} cartId - Shopify cart ID
 */
export const setCartId = cartId => {
  if (!cartId) {
    console.warn("No cart ID provided");
    return;
  }
  const cookieName = getCartCookieName();
  const mainDomain = getMainWebsiteDomain();

  Cookies.set(cookieName, cartId, {
    domain: `.${mainDomain}`,
    path: "/",
    expires: 30,
  });
};

/**
 * Get cart ID from cookie
 * @returns {string|null} Cart ID or null
 */
export const getCartId = () => {
  const cookieName = getCartCookieName();
  const cartId = Cookies.get(cookieName);
  return cartId || null;
};

/**
 * Remove cart ID cookie
 */
export const removeCartId = () => {
  const cookieName = getCartCookieName();
  const mainDomain = getMainWebsiteDomain();

  Cookies.remove(cookieName, {
    domain: `.${mainDomain}`,
    path: "/",
  });
};

/**
 * Check if cart ID exists
 * @returns {boolean} True if cart exists
 */
export const hasCartId = () => {
  return !!getCartId();
};

/**
 * Debug cart storage state
 */
export const debugCartStorage = () => {
  console.log("=== DEBUG we remove after we make sure cross domain works on staging ===");

  const currentLanguage = getCurrentLanguageCode(LANGUAGE_FR_CODE);
  const cookieName = getCartCookieName();
  const mainDomain = getMainWebsiteDomain();

  console.log("Current language:", currentLanguage);
  console.log("Cookie name:", cookieName);
  console.log("Main domain:", mainDomain);
  console.log("Current cart ID:", getCartId());

  // Show both cookies
  console.log("US cookie:", Cookies.get(PELICAN_CHECKOUT_COOKIES_US));
  console.log("CA cookie:", Cookies.get(PELICAN_CHECKOUT_COOKIES_CA));

  // All cookies
  console.log("All cookies:", document.cookie);

  console.log("===============================");
};
if (typeof window !== "undefined") {
  window.debugCartStorage = debugCartStorage;
}
